import { call, put, takeLatest } from 'redux-saga/effects';
import { Language } from '../../../helpers/types';
import { languagesApi } from '../../../services/languagesApi';
import { languagesActions as actions } from '.';

function* handleFetch() {
  try {
    const data = (yield call(languagesApi.list, true)) as Language[];
    yield put(actions.fetchSuccess(data));
  } catch {
    yield put(actions.fetchFailure());
  }
}

export function* languagesSaga() {
  yield takeLatest(actions.fetchRequest.type, handleFetch);
}
